<template>
    <div class="position-relative">
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <div class="row align-items-lg-center mb-n3 w-100">
            <div class="col-lg-7 mb-3">
                <doughnut-chart
                    ref="chart"
                    :height="310"
                    :chart-data="chartData"
                    :options="options"
                    class="chart"
                ></doughnut-chart>
            </div>
            <div class="col-lg-5 mb-3">
                <ul class="list mb-n3">
                    <li
                        v-for="(item, index) in chartData.legend"
                        :key="item.label"
                        class="d-flex gap-2 mb-3 text-small"
                    >
                        <span
                            :style="{ backgroundColor: colors[index] }"
                            class="legend-color"
                        />

                        <div class="d-flex flex-column gap-05">
                            <span class="font-weight-bold">
                                {{ item.label }}
                            </span>
                            <span v-if="item.sublabel">
                                {{ item.sublabel }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import { DoughnutChart } from '../charts';
import UiSpinner from '../ui/spinner.vue';

export default {
    name: 'WidgetDoughnutChart',
    components: {
        DoughnutChart,
        UiSpinner,
    },
    props: {
        colors: {
            type: Array,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            chartData: {},
            isLoading: false,
            options: {
                legend: {
                    display: false,
                },
                responsive: true,
            },
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...mapState('dashboard', [
            'query',
        ]),
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const { data: { data } } = await axios.get(this.url, { params: this.query });

            const dataset = data.map(item => item.value);
            const labels = data.map(item => item.label);

            this.chartData = {
                datasets: [
                    {
                        data: dataset,
                    },
                ],
                labels,
                legend: data.map(item => {
                    return {
                        label: item.label,
                        sublabel: item.sublabel,
                    };
                }),
            };

            this.chartData.datasets = this.chartData.datasets.map(dataset => ({
                backgroundColor: this.colors,
                ...dataset,
            }));

            this.isLoading = false;
        },
    },
    watch: {
        query() {
            this.fetch();
        },
    },
};
</script>
